<template>
    <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
    <div
        class="appMain"
        v-if="appMainIs"
    >
        <Navigation :newsData="newsData"></Navigation>
        <div class="mainApp">
            <router-view />
        </div>
        <FooterModel :newsData="newsData"></FooterModel>

        <Topping></Topping>
    </div>

</template>

<script setup>
import Navigation from "./components/Navigation.vue";
import FooterModel from "./components/FooterModel.vue";
import Topping from "./components/Topping.vue"

import { onBeforeMount, provide, ref } from 'vue';
// 获取可配置的信息
import { companyAddress, getNewsData } from './utils/api.js';

import { ElLoading } from 'element-plus'

import { useStore } from 'vuex';
const store = useStore();

provide('$imgUrl', "http://27.128.176.167:8102/jeecg-boot/officialImage/20240315");

let appMainIs = ref(false);
// { "id": "1544254177384226817", "title": "卓信通信股份有限公司", "address": "总部地址:河北省石家庄市裕华区怀特商业广场A座21层 ,邮编:050000", "thirdPartyIcons": "https://2l916746t7.goho.co/jeecg-boot/officialImage/20240313/admin_1710316183868.png", "sort": 1, "homeVideo": "https://2l916746t7.goho.co/jeecg-boot/officialImage/20240314/admin_1710379831258.mp4", "recordNo": "冀ICP备14014867号-1" }

let newsData = ref({});

onBeforeMount(() => {
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(255,255,255, 0.7)',
    })
    // 官网基本信息
    companyAddress().then((res) => {
        // console.log("res", res)

        appMainIs.value = true;
        localStorage.setItem("webData", JSON.stringify(res.data));

        loading.close();
    })

    // 新闻所有信息
    getNewsData().then((res) => {
        let totalData = res.data;

        newsData.value = totalData;
    })
})

</script>

<style lang="scss">
@media only screen and (max-width: 2800px) and (min-width: 1921px) {
    html,
    body {
        font-size: 25px !important;
    }
}
@media only screen and (max-width: 1920px) and (min-width: 1681px) {
    html,
    body {
        font-size: 18px !important;
    }
}
@media only screen and (max-width: 1680px) and (min-width: 1441px) {
    html,
    body {
        font-size: 15px !important;
    }
}
@media only screen and (max-width: 1440px) and (min-width: 1025px) {
    html,
    body {
        font-size: 12px !important;
    }
}
@media only screen and (max-width: 1024px) {
    html,
    body {
        font-size: 10px !important;
    }
}

#app {
    width: 100%;
    height: 100vh;
    min-width: 1024px;
    min-height: 668px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: "Source Han Sans";
    // text-align: center;
    // color: #2c3e50;
}

* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.mainApp {
    // position: relative;
    // top: 5rem;
    margin-top: 5rem;
}

.twoSpace {
    text-indent: 2em;
    margin-bottom: 1rem;
}

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
